import React, { useContext } from "react";
import DraftStateContext from "../../contexts/draftStateContext";
import ChooseSpots from "./ChooseSpots";
import OnClock from "./OnClock";

export default function Header() {
  const draftState = useContext(DraftStateContext);

  return <>{draftState.info.isChoosingSpots ? <ChooseSpots /> : <OnClock />}</>;
}
